<!-- <h4 class="title">Payment Summary</h4> -->

<div class="doc-table">

<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

    <ng-template pTemplate="header">

            <tr style="text-align: center;"  class="thhead">
                <th rowspan="2" style="width: 60px;">S.No</th>
                <th rowspan="2">Date Of Payment</th>
                <th rowspan="2">Mode Of Payment</th>
                <th rowspan="2">Cheque No.</th>
                <th rowspan="2">Cheque Date</th>
                <th rowspan="2">Due Date</th>
                <th rowspan="2">FC/EXR*</th>
                <th>Principal Amount</th>
                <th>Interest Amount</th>
                <th>BCC Amount</th>
                <th>LPC Amount</th>
                <th>Other Amount</th>
                <th>Total Amount</th>
            </tr>
              <tr class="thhead">
                <th>FC/Base</th>
                <th>FC/Base</th>
                <th>FC/Base</th>
                <th>FC/Base</th>
                <th>FC/Base</th>
                <th>FC/Base</th>
              </tr>

    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
            <td style="text-align: center;">{{i+1}}</td>
            <td>20/10/2020</td>
            <td>Cash</td>
            <td>10255254525682</td>
            <td>20/10/2020</td>
            <td>25/10/2020</td>
            <td></td>
            <td>0.00/1,440.37</td>
            <td>0.00/767.37</td>
            <td>0.00/0.00</td>
            <td>0.00/0.00</td>
            <td>0.00/0.00</td>
            <td>0.00/2,208.00</td>
           
            <!-- <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i>
            </td> -->
        </tr>
    </ng-template>
 </p-table>  </div>

</div>
